import { ChangeEvent, Fragment, useState } from "react";
import Avatar from "@mui/material/Avatar";
import {
  Button,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { RoadmapDto } from "@lib/ShiOneClient";
import shiColors from "shared-ui/src/theme/shiColors";
import useCreateRoadmap from "shared-ui/src/features/roadmaps-feature/hooks/useCreateRoadmap";
import { initialRoadmapState } from "shared-ui/src/features/roadmaps-feature/utils/roadmapProps";

const SendToDialogRoadmapsView = ({
  roadmaps,
  setShowSnackbar,
  handleRoadmapClick,
}: {
  roadmaps: RoadmapDto[];
  setShowSnackbar: (param: boolean) => void;
  handleRoadmapClick: (roadmap: RoadmapDto) => void;
}) => {
  const theme = useTheme();
  const mutation = useCreateRoadmap();

  const [newRoadmapName, setNewRoadmapName] = useState<string | null>(null);
  const handleChangeNewRoadmap = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setNewRoadmapName(event.target.value);
  };
  const handleSubmitNewRoadmap = () => {
    const newRoadmap = { ...initialRoadmapState, name: newRoadmapName };
    mutation.mutate(newRoadmap as RoadmapDto);
    if (mutation.isError) {
      setShowSnackbar(true);
    }
    const roadmap = mutation.data?.roadmap;
    handleRoadmapClick(roadmap as RoadmapDto);
  };
  return (
    <List>
      {roadmaps?.map((roadmap) => {
        const initiatives = roadmap?.roadmapItems?.filter(
          (roadmapItem) => roadmapItem.parentRoadmapItem === undefined,
        );
        return (
          <Fragment key={roadmap.id}>
            <ListItem>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                padding={1}
              >
                <Grid item xs display="flex" alignItems="center" gap={2}>
                  <ListItemIcon sx={{ minWidth: "auto" }}>
                    <FactCheckIcon />
                  </ListItemIcon>
                  <ListItemText primary={roadmap.name} />

                  <Button
                    variant="contained"
                    disableElevation
                    sx={{
                      borderRadius: 4,
                      backgroundColor: shiColors.gray.lighter,
                      "&:hover": {
                        backgroundColor: theme.palette.grey[300],
                      },
                      textTransform: "none",
                      color: theme.palette.common.black,
                    }}
                    startIcon={
                      <Avatar sx={{ width: 24, height: 24 }}>
                        {initiatives?.length}
                      </Avatar>
                    }
                    onClick={() => handleRoadmapClick(roadmap)}
                  >
                    <Typography>Initiatives</Typography>
                  </Button>
                </Grid>
                <Grid item>
                  <ListItemIcon sx={{ minWidth: "auto" }}>
                    <IconButton onClick={() => handleRoadmapClick(roadmap)}>
                      <ChevronRightIcon />
                    </IconButton>
                  </ListItemIcon>
                </Grid>
              </Grid>
            </ListItem>
            <Divider />
          </Fragment>
        );
      })}
      <ListItem>
        <Grid
          container
          padding={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs>
            <TextField
              fullWidth
              placeholder="Create New Plan"
              variant="outlined"
              size="small"
              onChange={handleChangeNewRoadmap}
            />
          </Grid>
          <Grid item>
            <ListItemIcon sx={{ minWidth: "auto" }}>
              <IconButton onClick={handleSubmitNewRoadmap}>
                <ChevronRightIcon />
              </IconButton>
            </ListItemIcon>
          </Grid>
        </Grid>
      </ListItem>
    </List>
  );
};

export default SendToDialogRoadmapsView;
